import IContainerStatusViewModel from "interfaces/IContainerStatusViewModel";

const SiteAndRegionTemplate = (props: IContainerStatusViewModel): any => {
  const container = { props };
  return (
    <>
      <span className="fw-bold">
        {container.props.hwrcSite}
      </span>
      <br />
      <span>
        {container.props.region}
      </span>
    </>
  );
};
export default SiteAndRegionTemplate;
